import { useQuery } from '@tanstack/react-query';
import { PromotionsService } from '../services';

export const getPromotionsQueryKey = () => ['GET_PROMOTIONS'];

export const useGetPromotions = (options) => {
  const { data, error, isFetching, isLoading, isError } = useQuery({
    queryKey: getPromotionsQueryKey(),
    queryFn: () => PromotionsService.getPromotions(),
    retry: false,
    // Keep the list fresh for a while so opening the payout modal (a second
    // observer of this query) reuses the cache instead of refetching and
    // blanking the list. Mutations invalidate the query, so edits still refresh.
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: options?.refetchOnWindowFocus ?? false,
    enabled: options?.enabled ?? true,
  });

  return {
    promotions: data || [],
    error,
    isError,
    // isLoading is the initial load only; background refetches keep the list
    // on screen (isFetching is exposed separately for callers that want it).
    isLoading,
    isFetching,
  };
};
